// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"37f390d2","791":"c0474ccc","839":"41d947ef","863":"17e81688"}[chunkId] + ".chunk.css";
};